<div class="control-line mat-elevation-z8">
    <div class="filter-actions-line">
      <app-select-search (selectedItemId)="onPredictWeekChange($event)" 
        [selectItems]="predictWeeks" selectTitle="Predict Week" [setId]="weekId"></app-select-search>
      <!-- months-select.component.html -->
      <mat-form-field appearance="outline">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
          <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
          <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <app-select-search [selectItems]="marketData" selectTitle="Market" [setId]="marketId" 
       (selectedItemId)="onMarketReceived($event)"></app-select-search>
      <app-select-search (selectedItemId)="onDisposalSiteChange($event)"
       [selectItems]="disposalSites" selectTitle="Disposal Site" [setId]="siteId"></app-select-search>
      <button id="btnPredictLoad" data-testid="btnPredictLoad" mat-raised-button color="primary" (click)="onPredictLoad()">
        <mat-icon>search</mat-icon>Predict Load
      </button>
      <!-- [disabled]="selectedRow.length === 0" -->
      <button id="btnConfirm" data-testid="btnConfirm" mat-raised-button color="primary" disabled="true"
        (click)="onConfirm()">
        Confirm
      </button>
    </div>
  </div>
  <div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
      <!-- <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <div>
            <mat-checkbox [checked]="isSelected(element)" (change)="onRowSelectionChange(element, $event.checked)">
            </mat-checkbox>
          </div>
        </td>
      </ng-container> -->
      
      <ng-container matColumnDef="day">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Day </th>
        <td mat-cell *matCellDef="let element"> {{element.day | date: 'MM/dd/yyyy'}} </td>
      </ng-container>
      
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef> Customer </th>
        <td mat-cell *matCellDef="let element"> {{element.customer}} </td>
      </ng-container>
      
      <ng-container matColumnDef="stream">
        <th mat-header-cell *matHeaderCellDef> Stream </th>
        <td mat-cell *matCellDef="let element"> {{element.stream}} </td>
      </ng-container>
      <ng-container matColumnDef="tank">
        <th mat-header-cell *matHeaderCellDef>Tank</th>
        <td mat-cell *matCellDef="let element"> {{element.tank}} </td>
      </ng-container>
      <ng-container matColumnDef="hauler">
        <th mat-header-cell *matHeaderCellDef>Tank</th>
        <td mat-cell *matCellDef="let element"> {{element.tank}} </td>
      </ng-container>
      <ng-container matColumnDef="uom">
        <th mat-header-cell *matHeaderCellDef>UOM</th>
        <td mat-cell *matCellDef="let element"> {{element.uom}} </td>
      </ng-container>
      <ng-container matColumnDef="projectedQuantity">
        <th mat-header-cell *matHeaderCellDef> Projected<br>Quantity </th>
        <td mat-cell *matCellDef="let element"> {{element.projectedQuantity}} </td>
      </ng-container>
      <ng-container matColumnDef="predictedGas">
        <th mat-header-cell *matHeaderCellDef> Predicted Gas(cfm) </th>
        <td mat-cell *matCellDef="let element"> {{element.predictedGas}} </td>
      </ng-container>
      <ng-container matColumnDef="fat">
        <th mat-header-cell *matHeaderCellDef>Fat</th>
        <td mat-cell *matCellDef="let element"> {{element.fat}} </td>
      </ng-container>
      <ng-container matColumnDef="carbs">
        <th mat-header-cell *matHeaderCellDef>Carbs</th>
        <td mat-cell *matCellDef="let element"> {{element.carbs}} </td>
      </ng-container>
      <ng-container matColumnDef="protein">
        <th mat-header-cell *matHeaderCellDef>Protein</th>
        <td mat-cell *matCellDef="let element"> {{element.protien}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
      <!-- No Data Row -->
      <tr class="mat-row hover:bg-transparent" *matNoDataRow>
        <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
          No data found.
        </td>
      </tr>
    </table>
  </div>